// extracted by mini-css-extract-plugin
export default {"cardContainer":"WhyChooseUsCard_cardContainer__wSnh2","icon":"WhyChooseUsCard_icon__MhSYJ","title":"WhyChooseUsCard_title__IWDde"};